import React from "react";

export function DNAForm() {
  return <p>Formulario de ADN</p>;
}
